import {
  SEND_OTP,
  SEND_OTP_SUCCESSFUL,
  SEND_OTP_FAILED,
  VERIFY_OTP, VERIFY_OTP_FAILED, VERIFY_OTP_SUCCESSFUL
} from "./actionTypes"

export const sendOtp = (user, callback) => {
  return {
    type: SEND_OTP,
    payload: { user, callback },
  }
}

export const sendOtpSuccessful = user => {
  return {
    type: SEND_OTP_SUCCESSFUL,
    payload: user,
  }
}

export const sendOtpFailed = user => {
  return {
    type: SEND_OTP_FAILED,
    payload: user,
  }
}
export const verifyOtp = (user, callback) => {
  return {
    type: VERIFY_OTP,
    payload: { user, callback },
  }
}

export const verifyOtpSuccessful = user => {
  return {
    type: VERIFY_OTP_SUCCESSFUL,
    payload: user,
  }
}

export const verifyOtpFailed = user => {
  return {
    type: VERIFY_OTP_FAILED,
    payload: user,
  }
}
